function announcebar() {
  /*setTimeout(function(){
    $(function () {
      var startTime = +new Date();
      var slider = $('.announce-slider'),
          items = slider.find('.announce-slide');
      var sliderHeight = slider.height(),
          itemsNum = items.length,
          itemHeight = items.height();
      slider.css('top', '-' + (sliderHeight + itemHeight) + 'px');
      var startPos = slider.css('top');
      items.first().before(items.clone());
      items.last().after(items.clone());
      scrollItems(slider,sliderHeight,itemHeight,startPos,4);
      var endTime = +new Date();
      var diff = endTime - startTime;
      setInterval(function(){ 
        scrollItems(slider,sliderHeight,itemHeight,startPos,4);
      }, 1500);
    });
    function scrollItems(container, targetsHeight, increment, startPos, temps) {
      var secs = temps * 1000;
      container.animate({
        'top': '-' + ((targetsHeight * 2) + increment) + 'px'
      }, secs, 'linear', function () {
        container.css('top', startPos);
      });
    }
  }, 3000);*/
  (function ($) {
    var defaults = {
      container: ".announce-centerinr",
      sections: "li",
      duration: 1000,
      loop: true,
      currentClass: "current",
      direction: "up",
    };
    var opts = {},
      container,
      sections,
      iIndex = 0,
      content,
      contentHeight,
      contentChildHeight,
      temp,
      currentClass,
      arrElements = [],
      intervalID,
      duration;
    var ST = ($.fn.scrollText = function (options) {
      opts = $.extend({}, defaults, options || {});
      (container = $(opts.container)),
        (sections = container.find(opts.sections));
      sections.each(function (index, item) {
        arrElements.push(item);
      });
      this.children("ul").addClass("ulzone");
      content = $(".ulzone").eq(0);
      contentHeight = content.height();
      contentChildHeight = content.children().eq(0).outerHeight();
      temp = contentChildHeight;
      duration = opts.duration;
      currentClass = opts.currentClass;
      return this.each(function () {
        _initLayout(this);
      });
    });
    ST.up = function () {
      content.animate(
        {
          marginTop: "-" + contentChildHeight,
        },
        1000
      );
      arrElements.removeClass(currentClass);
      iIndex += 1;
      $(arrElements[iIndex]).addClass(currentClass);
      if (contentHeight === contentChildHeight) {
        content.animate(
          {
            marginTop: "-" + contentChildHeight,
          },
          "normal",
          ST.over
        );
      } else {
        contentChildHeight += temp;
      }
    };
    ST.over = function () {
      content.attr("style", "margin-top:0");
      contentChildHeight = temp;
      iIndex = 0;
      arrElements.removeClass(currentClass);
      $(arrElements[iIndex]).addClass(currentClass);
    };
    function _initLayout(t) {
      var that = t;
      content.clone().insertAfter(content);
      _handleStyle(that);
      _scroll();
      _hover($(t));
    }
    function _handleStyle(t) {
      arrElements = $(t).find("li");
      var liCount = arrElements.length;
      arrElements.eq(iIndex).addClass(currentClass);
    }
    function _scroll() {
      if (intervalID) {
        clearInterval(intervalID);
      }
      intervalID = setInterval(ST.up, duration);
    }

    function handleVisibilityChange() {
      if (document.hidden) {
        clearInterval(intervalID);
      } else {
        _scroll();
      }
    }

    function setupVisibilityChangeHandling() {
      if (typeof document.hidden !== "undefined") {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange,
          false
        );
        document.addEventListener(
          "visibilitychange",
          handleVisibilityChange,
          false
        );
      }
    }

    setupVisibilityChangeHandling();
  })(jQuery);
  $(function () {
    $(".announce-centerinr").scrollText({
      duration: 2000,
      loop: true,
    });
  });
  $(".announce-button").on("click", function (e) {
    $(".annouce-dropdown")
      .not('[data-list="' + $(this).data("region") + '"]')
      .slideUp();
    $(
      '.annouce-dropdown[data-list="' + $(this).data("region") + '"]'
    ).slideToggle();
  });
  $("body").on("click", function (e) {
    var seachbox = $(".announce-button,.annouce-dropdown");
    if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0) {
      $(".annouce-dropdown").slideUp();
    }
  });
  $(".desktop-weglot").on("click", function (e) {
    $(".annouce-dropdown").slideUp();
  });
  function countDowns() {
    $(".countdown").each(function (e) {
      var each_Data = $(this).data("time");
      var countDownDate = new Date(each_Data).getTime();
      var _this_count = $(this);
      var x = setInterval(function () {
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        $(_this_count).html(
          days + "d : " + hours + "h : " + minutes + "m : " + seconds + "s "
        );
        if (distance < 0) {
          clearInterval(x);
          $(_this_count).html("ENDED");
        }
      }, 1000);
    });
  }
  countDowns();
  setTimeout(function (e) {
    countDowns();
  }, 1000);
}
announcebar();
